import { saveAs } from 'file-saver';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';

export default class N18Tables extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;

        this.sid = Context.GetContext().Sid;

        this.CheckAll = this.CheckAll.bind(this);
        this.Check = this.Check.bind(this);
        this.Download = this.Download.bind(this);

        this.state = { tables: [] };
    }

    componentDidMount() {
        var self = this;
        var tables = Comm.CallServerFunction("n18_odit/odit_tables", { session: self.sid }).tables;
        this.setState({ tables: tables });
    }

    CheckAll(val) {
        console.log("val", val);
        var tables = this.state.tables;
        tables.forEach(x => x.checked = val);
        this.setState({ tables: tables });

    }

    Check(id, val) {
        console.log("val", val);
        var tables = this.state.tables;
        tables.filter(x => x.id == id)[0].checked = val;
        this.setState({ tables: tables });

    }



    Download() {
        var self = this;
        var tables = this.state.tables;
        tables.filter(x => x.checked == true).forEach(x => {
            var csv = Comm.CallServerFunction("n18_odit/odit_table", { session: self.sid, table: x.name }).csv;
            console.log("csv", csv);
            var file = new Blob([csv], { type: "text/plain;charset=utf-8" });
            saveAs(file, x.name + ".csv");

        });

    }

    render() {

        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }

        var self = this;
        console.log("state", self.state);
        return (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("n18odit")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-8">
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <input id="cbAll" type="checkbox" onChange={(e) => self.CheckAll(e.target.checked)} />
                                    <label htmlFor="cbInput">{Translation.Trans("all")}</label>

                                </li>
                                {
                                    self.state.tables.map(i =>
                                        <li className="list-group-item">

                                            <input type="checkbox" checked={i.checked} onChange={(e) => self.Check(i.id, e.target.checked)} />
                                            <label>{i.name}</label>

                                        </li>

                                    )
                                }
                            </ul>

                        </div>
                        <div className="col-md-4">
                            <button className="btn btn-primary" onClick={this.Download}>{Translation.Trans("download")}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/n18tables.js